import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import { NavLink } from "react-router-dom";
import { getInstances, getSearchInstances } from "../../Redux/actions/processes";
import ViewLogs from "./viewLogs";
import loader from "../../Assets/loaderTransaparent.gif";
import stringToDate from "../../Utilities/stringToDate";
import timeConversion from  "../../Utilities/timeConversion";
import "./index.css";

function Instances(props) {

  let { flow } = props;
  const [modal, setModal] = useState(false);
  const [instances, setInstances ] = useState([]);
  const [loading, setLoading] = useState(false);
  const [instanceLogs, setInstanceLogs] = useState('')
  let [currentPage, setCurrentPage] = useState('1')
  let [previousBtnPage,setPreviousBtnPage] = useState()
  let [nextBtnPage,setNextBtnPage] = useState()
  let [startIndex,setStartIndex]  = useState('0')
  let [endIndex,setEndIndex] = useState('10')
  let [totalPages,setTotalPages] = useState()
  let [offSet,setOffSet] = useState('0')
  let [limit,setLimit] = useState('10')
  const [search_data,setsearch_data] = useState()
    
  const toggle = async (logs) => {
    if(logs){
      if(!modal){
        setInstanceLogs(logs)
      }else{
        setInstanceLogs('')
      }
    }else{
      setLoading(true);
       let payload={
       offSet,limit
       }      
       let data = await getInstances(flow.id,payload);
       setLoading(false)
       if(data.rows.length > 0) { 
        setInstances(data.rows);
       }
    }
    setModal(!modal)
  };
  
  useEffect(() => {
    setLoading(true);
      async function fetchData() {
        let payload={
          offSet,limit
        }
        let data = await getInstances(flow.id,payload);
        setTotalPages(Math.ceil(data.count/10))
        setLoading(false)
        if(data.rows && data.rows.length > 0) { 
          setInstances(data.rows);
        }
      }
    fetchData();
  }, [flow,limit,offSet]);

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handleClick = (event) => {
    let payload;     
    if(currentPage < event.target.id){
        setOffSet(parseInt(offSet)+(10*(event.target.id-currentPage)))
        payload={
          offSet:parseInt(offSet)+(10*(event.target.id-currentPage)),limit
        }
    }else if( currentPage > event.target.id){    
        setOffSet(parseInt(offSet)-(10*(currentPage-event.target.id)))
        payload={
          offSet:parseInt(offSet)-(10*(currentPage-event.target.id)),limit
        }
    }
    else{
        setOffSet(offSet)
        payload={
          offSet,limit
        }
    }  
    setLoading(true)
    const fetchData = async () => {
      let data = await getInstances(flow.id,payload);
      setLoading(false)
      setInstances(data.rows)
    }
    fetchData()
    setCurrentPage(event.target.id)
  }

  const handlePrev = (event) => { 
    setPreviousBtnPage(parseInt(currentPage)-1)
    if(currentPage.endsWith('1') && currentPage!=='10'){
       setStartIndex(parseInt(startIndex)-10)
       setEndIndex(parseInt(endIndex)-10)    
    }
    setOffSet(parseInt(offSet)-10)
    let payload={
      offSet:parseInt(offSet)-10,
      limit
    }      
    setLoading(true)
    const fetchData = async () => {
      let data = await getInstances(flow.id,payload);
      setLoading(false)
      setInstances(data.rows)
    }
    fetchData()
    setCurrentPage((parseInt(currentPage) - 1).toString())
  }

  const handleNext = (event) => {
    setNextBtnPage(parseInt(currentPage)+1)
    if(currentPage.endsWith('0')){
      setStartIndex(parseInt(startIndex)+10)
      setEndIndex(parseInt(endIndex)+10)  
    }  
    setOffSet(parseInt(offSet)+10)
    let payload={
      offSet:parseInt(offSet)+10,
      limit
    }  
    setLoading(true)
    const fetchData = async () => {
      let data = await getInstances(flow.id,payload);
      setLoading(false)
      setInstances(data.rows)
    }
    fetchData()
    setCurrentPage((parseInt(currentPage) + 1).toString())
  }

  const fetchData = async () => {    
    setLoading(true);
    let payload={
      offSet,
      limit
    } 
    let data = await getInstances(flow.id,payload);
    setLoading(false);
    if (data.rows.length > 0) {
      setInstances(data.rows)  
    }
  };

  const handleChange = (e) =>{    
    setsearch_data(e.target.value)
    if(e.target.value <= 0){
      setsearch_data(null)
      fetchData()
    }
  }

  const handleSearch = async () =>{
    if(search_data){
        let data = await getSearchInstances(flow.id,search_data); 
        if(data){
          setInstances([data.rows])
        }
        else{
          setInstances([])
        }
    }
  }

  const keyPress = async(e) => {
    if (e.key === 'Enter' ){
      handleSearch()
    }
  }

  const renderPageNumbers = pageNumbers.slice(startIndex, endIndex).map(number => {      
          
    return (
        pageNumbers.length > 1 ? <button onClick={handleClick}  id={number} style={{padding:"5px 10px",border: "solid 1px #d2c5c5",display:"flex",justifyContent:"center",color:"black" ,marginTop:"-2px"}} className={number.toString() === currentPage? "active1":""} key={number}>
          {number}
        </button>:""
    );
  });

    if (loading) {
      return (
        <div className="main-content">
          <div className="header-content">
            <label>{flow.name}</label>
          </div>
          <div style={{ textAlign: "center", marginTop: "15%" }}>
            <img src={loader} width="125" alt="loading"></img>
          </div>
          <div className="pagination_button">
            {pageNumbers.length > 1 ? <button onClick={handlePrev} className="img_but" disabled={currentPage === '1'}>&laquo;</button>:""}
            {renderPageNumbers}
            {pageNumbers.length > 1 ? <button onClick={handleNext}  className="img_but" disabled={pageNumbers.length.toString() === currentPage && pageNumbers.length.toString()>endIndex ||pageNumbers.length.toString() === currentPage }>&raquo;</button>:""}
          </div>
        </div>
      );
    } else { 
      return (
        <div className="main-content">
          <div>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li className="breadcrumb-item">
                          <NavLink to="/processes">
                            Action Flows
                          </NavLink>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                            Instances 
                </li>
              </ol>
            </nav>
          </div>
          <div className="header title-search" >
            <label>{flow.name}</label>
            <div className="hd-search">
              <input type="number"  name="search_data" onChange={handleChange} onKeyPress={keyPress} placeholder="Search" style={{height:"39px",backgroundColor:"#f7f7f7",position:"absolute",right:"95px"}}/>
              <i className="fa fa-search" onClick={handleSearch} style={{height:"22px",color:"#938989",position:"absolute",right:"240px",padding:"7px",marginTop:"7px"}}></i>
            </div>
          </div>
           <div className="content mt-3">
             <div className="instanceTable">
            <Table hover responsive className="responsive-table">
              <thead>
                <tr>
                  <th>Queue Id</th>
                  <th>Version Number</th>
                  <th><div>E-Worker Machine Name</div></th>
                  <th><div>Execution Option</div></th>
                  <th>Execution Time</th>
                  <th>Status</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Log</th>
                </tr>
              </thead>
               <tbody className="table-body">
               {instances.map((obj, ind) => {
                  let INSTANCE_STATUS_TIME = window._env.REACT_APP_INSTANCE_STATUS_TIME;
                  if(parseInt(INSTANCE_STATUS_TIME) && obj.status.toUpperCase() === "INPROGRESS"){
                    let curr_date = new Date();
                    let prev_date = new Date(obj.created_at.slice(0, -1));
                    let diffTime = new Date(curr_date - prev_date);
                    var hour = diffTime.getUTCHours();
                    var day = diffTime.getUTCDate() - 1;
                    if(hour >= parseInt(INSTANCE_STATUS_TIME) && day > "0"){
                      obj.status = "ABANDONED";
                    }
                  }
                return(
                  <tr key={ind} >
                    <td>{obj.queue_id}</td>
                    <td>{obj.version_number}</td>
                    <td>{obj.worker_name === null?"-":obj.worker_name.length>10?<div className="tip">{obj.worker_name}
                    </div>:<div>-</div>}</td>
                    <td>{obj.execution_type === "0" ? "": obj.execution_type }</td>
                    <td>{timeConversion(obj.execution_time)}</td>
                    <td>{obj.status}</td>
                    <td>{obj.start_time === null ? "-":<div className="tip">{stringToDate(obj.start_time)}</div>}</td>
                    <td>{obj.end_time === null ? "-":<div className="tip">{stringToDate(obj.end_time)}</div>}</td>
                    <td style={{paddingLeft:"20px"}}>
                      <i onClick={() => toggle(obj)} className={obj.status === "INPROGRESS" ? "fas fa-desktop" : "fas fa-file-alt" } style={{fontSize:"1.2rem"}}></i>
                    </td>                
                  </tr>
                )
                })} 
              </tbody> 
            </Table>
            </div>
          </div> 
          <div className="pagination_button">
            {pageNumbers.length > 1 ? <button onClick={handlePrev} className="img_but" disabled={currentPage === '1'}>&laquo;</button>:""}
            {renderPageNumbers}
            {pageNumbers.length > 1 ? <button onClick={handleNext}  className="img_but" disabled={pageNumbers.length.toString() === currentPage && pageNumbers.length.toString()>endIndex ||pageNumbers.length.toString() === currentPage }>&raquo;</button>:""}
          </div>

          {modal ? (<ViewLogs logs={instanceLogs} toggle={() => toggle()} modal={modal}/> ) : null}
        </div>
      );
    }
}
export default Instances;
